module.exports = __webpack_public_path__ + "static/media/loader-block-user.fd0120c3.svg";